import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FormEntry from '../../../models/FormEntry'
import { Form, Grid, Header } from 'semantic-ui-react'
import Section from '../Inputs/Section'
import Input from '../Inputs/Input'
import Select from '../Inputs/Select'
import { FromTo, InterrupteurModel } from '../../../utils/FormSelectHelper'
import { observer } from 'mobx-react'
import SelectMultiple from '../Inputs/SelectMultiple'
import Checkbox from '../Inputs/Checkbox'

@observer
class RIACOGI000 extends Component {
  static propTypes = {
    equipment: PropTypes.instanceOf(FormEntry),
    changeMenuType: PropTypes.func.isRequired
  }

  componentDidMount () {
    const { changeMenuType } = this.props
    changeMenuType('search', {
      label: 'Rechercher équipement par zone protégée ou localisation',
      enableShowAll: true,
      searchFields: [
        { fieldName: 'zoneProtegee' },
        { fieldName: 'localisationComposante' }
      ]
    })
  }

  render () {
    const { equipment } = this.props
    return (
      <Form>
        <Section
          title={(<Header as='h2'>DÉFICIENCES</Header>)}
          equipment={equipment}
          secondaryField={<Checkbox name='verComGicleur' formEntry={equipment} label='Vérification Effectuée' />}
          ignore={(
            <Form.Group widths='equal'>
              <Input name='zoneProtegee' formEntry={equipment} label='Zone protégée' />
              <Input name='localisationComposante' formEntry={equipment} label='Localisation de la composante' />
              <Input name='adresseComposante' formEntry={equipment} label='Adresse de la composante' />
            </Form.Group>)}
        >
          <Grid>
            <Grid.Row columns={3}>
              <Grid.Column className='compact'>
                <SelectMultiple
                  options={[
                    { value: 'osyValve', text: 'O.S.Y.Valve' },
                    { value: 'btflyValve', text: 'BT-FLY Valve' },
                    { value: 'ballValve', text: 'Ball Valve' },
                    { value: 'gateValve', text: 'Gate Valve' }
                  ]} label='Modèle de valve' formEntry={equipment}
                />
              </Grid.Column>
              <Grid.Column className='compact'>
                <Select
                  name='modeleAccouplement' formEntry={equipment} label="Modèle d'accouplement" options={[
                    { value: 'rainure', text: 'Rainuré' },
                    { value: 'file', text: 'Filé' },
                    { value: 'bride', text: 'Bridé' },
                    { value: 'wafer', text: 'Wafer' }
                  ]}
                />
              </Grid.Column>
              <Grid.Column className='compact'>
                <Select name='avertisseurDebit' formEntry={equipment} label='Interrupteur' options={InterrupteurModel()} />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={3}>
              <Grid.Column>
                <Header>Vérification</Header>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={3}>
              <Grid.Column className='compact'>
                <Form.Group inline>
                  <Select name='delaiSecMin' formEntry={equipment} options={FromTo(0, 5)} label='Délai min' />
                  <Select name='delaiSecSec' formEntry={equipment} options={FromTo(1, 60)} label='sec' />
                </Form.Group>
              </Grid.Column>
              <Grid.Column className='compact'>
                <Select
                  name='dimension' formEntry={equipment} options={[
                    { value: '0.5', text: '½' },
                    { value: '1', text: '1' },
                    { value: '1.25', text: '1 ¼' },
                    { value: '1.5', text: '1 ½' },
                    { value: '1.75', text: '1 ¾' },
                    { value: '2', text: '2' },
                    { value: '2.5', text: '2 ½' },
                    { value: '3', text: '3' },
                    { value: '3.5', text: '3 ½' },
                    { value: '4', text: '4' },
                    { value: '5', text: '5' },
                    { value: '6', text: '6' },
                    { value: '8', text: '8' },
                    { value: '10', text: '10' },
                    { value: '12', text: '12' }
                  ]} label='Dimension'
                />
              </Grid.Column>
              <Grid.Column className='compact'>
                <SelectMultiple
                  options={[
                    { value: 'alarme', text: 'Alarme' },
                    { value: 'cadenasse', text: 'Cadenassé' },
                    { value: 'supervisee', text: 'Supervision' },
                    { value: 'trouble', text: 'Trouble' }
                  ]} formEntry={equipment} label='Signal'
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={2}>
              <Grid.Column className='compact' verticalAlign='middle'>
                <SelectMultiple
                  options={[
                    { value: 'adequat', text: 'Adéquat' },
                    { value: 'nonConforme', text: 'Non-conforme' },
                    { value: 'aRemplacer', text: 'À remplacer' }
                  ]} formEntry={equipment} label='Remarques'
                />
              </Grid.Column>
              <Grid.Column className='compact' verticalAlign='middle' width={8}>
                <Input name='autre' formEntry={equipment} label='Autre' />
              </Grid.Column>

            </Grid.Row>
          </Grid>
        </Section>
      </Form>
    )
  }
}

export default RIACOGI000
